(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["activate-account"]) return;
  try {
    
	$(document).ready(function() {
		var buttons = $('.mobile_dropdown .btn');

		buttons.on('click', function () {
			$(this).toggleClass('is-active');
			$(this).closest('.grid').find('.mobile_dropdown__holder').toggleClass('is-active');
		});
	});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customer-care-sub"]) return;
  try {
    
	$(document).ready(function(){
		var $panelTitles = $('.tab-item .h2');

		$panelTitles.each(function(){
			$(this).on('click', function(){
				if ($(this).next().is(':visible')) {
					$(this).next().css('display','none')
				} else {
					$(this).next().css('display','block')
				}
			});
		});
	});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customer-care"]) return;
  try {
    
				$(document).ready(function(){
					var $tablist =  $('.customer-navigation .icon_tab-link');
					var $panels = $('.tabs-content .tab-item');

					var activeTab = function (link, tab) {
						$tablist.removeClass('is-active');
						link.addClass('is-active');

						$panels.removeClass('is-active');
						tab.addClass('is-active');
					};

					$tablist.on('click', function (e) {
						e.preventDefault();
						var $tabToShow =  $(this).attr('href');

						if (!$($tabToShow).hasClass('is-active')) {
							$tablist.removeClass('is-active');
							$(this).addClass('is-active');
							$('.tabs-content .tab-item').removeClass('is-active');
							$($tabToShow).addClass('is-active');
						}
					});

					var $panelTitles = $('.tab-item .h2');

					$panelTitles.each(function(){
						$(this).on('click', function(){
							if ($(this).next().is(':visible')) {
								$(this).next().css('display','none')
							} else {
								$(this).next().css('display','block')
							}
						});
					});

					// if hash on a the url open a tab
					if(window.location.hash) {
						var hash = window.location.hash.substring(1);
						var tab = '#'+hash;
						if ($(tab).is(":visible") === false && $(tab).length > 0 ) {
							activeTab ( $("a[href$='"+tab+"']"), $(tab));
						}
					}
				});
      
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["delivery"]) return;
  try {
    
	$(document).ready(function(){
		var $panelTitles = $('.rte h2');

		$panelTitles.each(function(){
			$(this).on('click', function(){
				if ($(this).next().is(':visible')) {
					$(this).next().css('display','none')
				} else {
					$(this).next().css('display','block')
				}
			});
		});
	});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
		$(document).ready(function(){
			var $tablist = $('.related-products .tabs-container a');

			$tablist.on('click', function (e) {
				e.preventDefault();
				var $tabToShow =  $(this).attr('href');
				var $gallery_id = $(this).data('gallery');
				if (!$($tabToShow).hasClass('is-active')) {
					$tablist.removeClass('is-active');
					$(this).addClass('is-active');
					$('.related-products .tab-list__item').removeClass('is-active');
					$($tabToShow).addClass('is-active');

					$('.gallery-slick-'+$gallery_id).slick('refresh');
				}
			});
		});
	
  } catch(e) { console.error(e); }
})();
})();
